import clsx from 'clsx';
import { FC, MouseEventHandler } from 'react';
import { SpinnerIcon } from 'components/svg';

interface Props {
  isLoading: boolean;
  className?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
}

const ButtonBasic: FC<Props> = ({
  isLoading = false,
  className,
  disabled,
  children,
  onClick,
  type = 'submit',
  ...rest
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (type === 'button') {
      e.preventDefault();
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      onClick={handleClick}
      type={type}
      aria-label="submit"
      disabled={isLoading || disabled}
      className={clsx(
        'px-4 py-2 text-sm rounded shadow-md focus:outline-none',
        disabled
          ? 'text-gray-100 bg-gray-300'
          : 'text-white bg-indigo-500 hover:bg-green-500',
        className
      )}
      {...rest}
    >
      {isLoading ? <SpinnerIcon /> : children}
    </button>
  );
};

export default ButtonBasic;